import {ArticleType} from '@wp-content-publisher/typings-lib';
import {apiRequest} from '../../../shared/utils/api-request.helper.ts';

export const searchArticle = async (search: string): Promise<ArticleType[]> =>
    await apiRequest({
        url: '/articles',
        queryParams: {search}
    });